import { ReactNode } from 'react'
import { Text } from '@app/components/core/typography/Text'
import { useTranslations } from '@i18n/useLanguage'

export const LoaderWrapper = ({
  loading,
  children,
}: {
  loading: boolean
  children?: ReactNode
}) => {
  const translations = useTranslations().app

  if (loading) {
    return <Text.Medium>{translations.common.loading}</Text.Medium>
  }

  return children ?? null
}
